import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import action from "./Actions";
import Common from "./Common";
class Header extends Common {
  constructor(props) {
    super(props);
    var has_local_data = this.getFromStorage("encdata") ? 1 : 0;
    var localdata = has_local_data
      ? this.decrypt(this.getFromStorage("encdata"), 0)
      : "";
    this.state = {
      apiUrl: this.decryptconfigdata("apiUrl"),
      user_name: has_local_data ? localdata.data?.name : "",
      attachment: has_local_data ? localdata.data?.profile_image_url : "",
      emp_first_name: has_local_data
        ? localdata.data?.name.charAt(0).toUpperCase()
        : "",
      localdata: localdata,
      userDetails: [],
      fields: {},
      app_token: "",
    };
    this.logout = this.logout.bind(this);
  }
  componentDidUpdate = (prevProps, prevState) => {
    const app_token = this.getFromStorage("app_token");
    if (prevProps !== this.props) {
      this.setState({ ...this.state, app_token: app_token });
    }
  };
  hideMenu = () => {
    this.props.toggleMenu();
  };
  componentDidMount = () => {
    const data = this.getCommonData();
    this.setState({ ...this.state, app_token: data.app_token });
    const checkUserDetails = this.getFromStorage("user_details");
    if (checkUserDetails) {
      const userDetailsParse = JSON.parse(checkUserDetails);
      const getUserName = userDetailsParse.find(
        (item) => item.app_token === data.app_token
      )?.name;
      this.setState({
        ...this.state,
        userDetails: userDetailsParse,
        user_name: getUserName,
      });
    }
  };

  render() {
    let breadcrumb = "";
    if (this.props.brecum_name?.name == "") {
      breadcrumb = this.props.brecum_page;
    } else {
      breadcrumb = (
        <Link to={`${this.props.brecum_name?.link}`} className="muBtn _link">
          {this.props.brecum_page}
        </Link>
      );
    }
    return (
      this.checklogion() && (
        <div className="position-sticky top-0">
          <nav className="mu-breadcrumb" aria-label="breadcrumb">
            <div
              className={`d-flex align-items-center ${
                this.props.hasOwnProperty("pageName") ? "flter_show_header" : ""
              }`}
            >
              {this.props.hasOwnProperty("pageName") && (
                <>
                  {!this.props.toggleMenuAction ? (
                    this.props.hasOwnProperty("pageName") && (
                      <svg
                        width="98"
                        height="32"
                        viewBox="0 0 98 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={this.hideMenu}
                      >
                        <path
                          d="M20 12L12 20"
                          stroke="#202223"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12 12L20 20"
                          stroke="#202223"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M29.0568 20V11.2727H30.1136V15.1591H34.767V11.2727H35.8239V20H34.767V16.0966H30.1136V20H29.0568ZM37.8033 20V13.4545H38.8089V20H37.8033ZM38.3146 12.3636C38.1186 12.3636 37.9496 12.2969 37.8075 12.1634C37.6683 12.0298 37.5987 11.8693 37.5987 11.6818C37.5987 11.4943 37.6683 11.3338 37.8075 11.2003C37.9496 11.0668 38.1186 11 38.3146 11C38.5107 11 38.6783 11.0668 38.8175 11.2003C38.9595 11.3338 39.0305 11.4943 39.0305 11.6818C39.0305 11.8693 38.9595 12.0298 38.8175 12.1634C38.6783 12.2969 38.5107 12.3636 38.3146 12.3636ZM43.1225 20.1364C42.5771 20.1364 42.0955 19.9986 41.6779 19.723C41.2603 19.4446 40.9336 19.0526 40.6978 18.5469C40.462 18.0384 40.3441 17.4375 40.3441 16.7443C40.3441 16.0568 40.462 15.4602 40.6978 14.9545C40.9336 14.4489 41.2617 14.0582 41.6822 13.7827C42.1026 13.5071 42.5884 13.3693 43.1396 13.3693C43.5657 13.3693 43.9023 13.4403 44.1495 13.5824C44.3995 13.7216 44.5898 13.8807 44.7205 14.0597C44.854 14.2358 44.9577 14.3807 45.0316 14.4943H45.1168V11.2727H46.1225V20H45.1509V18.9943H45.0316C44.9577 19.1136 44.8526 19.2642 44.7163 19.446C44.5799 19.625 44.3853 19.7855 44.1325 19.9276C43.8796 20.0668 43.543 20.1364 43.1225 20.1364ZM43.2589 19.233C43.6623 19.233 44.0032 19.1278 44.2816 18.9176C44.56 18.7045 44.7717 18.4105 44.9165 18.0355C45.0614 17.6577 45.1339 17.2216 45.1339 16.7273C45.1339 16.2386 45.0629 15.8111 44.9208 15.4446C44.7788 15.0753 44.5685 14.7884 44.2901 14.5838C44.0117 14.3764 43.668 14.2727 43.2589 14.2727C42.8327 14.2727 42.4776 14.3821 42.1935 14.6009C41.9123 14.8168 41.7006 15.1108 41.5586 15.483C41.4194 15.8523 41.3498 16.267 41.3498 16.7273C41.3498 17.1932 41.4208 17.6165 41.5629 17.9972C41.7077 18.375 41.9208 18.6761 42.2021 18.9006C42.4862 19.1222 42.8384 19.233 43.2589 19.233ZM50.8484 20.1364C50.2177 20.1364 49.6737 19.9972 49.2163 19.7188C48.7617 19.4375 48.4109 19.0455 48.1637 18.5426C47.9194 18.0369 47.7972 17.4489 47.7972 16.7784C47.7972 16.108 47.9194 15.517 48.1637 15.0057C48.4109 14.4915 48.7546 14.0909 49.195 13.804C49.6381 13.5142 50.1552 13.3693 50.7461 13.3693C51.087 13.3693 51.4237 13.4261 51.756 13.5398C52.0884 13.6534 52.391 13.8381 52.6637 14.0938C52.9364 14.3466 53.1538 14.6818 53.3157 15.0994C53.4776 15.517 53.5586 16.0312 53.5586 16.642V17.0682H48.5131V16.1989H52.5359C52.5359 15.8295 52.462 15.5 52.3143 15.2102C52.1694 14.9205 51.962 14.6918 51.6921 14.5241C51.4251 14.3565 51.1097 14.2727 50.7461 14.2727C50.3455 14.2727 49.9989 14.3722 49.7063 14.571C49.4165 14.767 49.1935 15.0227 49.0373 15.3381C48.881 15.6534 48.8029 15.9915 48.8029 16.3523V16.9318C48.8029 17.4261 48.8881 17.8452 49.0586 18.1889C49.2319 18.5298 49.4719 18.7898 49.7788 18.9688C50.0856 19.1449 50.4421 19.233 50.8484 19.233C51.1126 19.233 51.3512 19.196 51.5643 19.1222C51.7802 19.0455 51.9663 18.9318 52.1225 18.7812C52.2788 18.6278 52.3995 18.4375 52.4847 18.2102L53.4563 18.483C53.354 18.8125 53.1822 19.1023 52.9407 19.3523C52.6992 19.5994 52.4009 19.7926 52.0458 19.9318C51.6907 20.0682 51.2915 20.1364 50.8484 20.1364ZM58.5998 11.2727H59.8612L62.8271 18.517H62.9293L65.8952 11.2727H67.1566V20H66.168V13.3693H66.0827L63.3555 20H62.4009L59.6737 13.3693H59.5884V20H58.5998V11.2727ZM71.8835 20.1364C71.2528 20.1364 70.7088 19.9972 70.2514 19.7188C69.7969 19.4375 69.446 19.0455 69.1989 18.5426C68.9545 18.0369 68.8324 17.4489 68.8324 16.7784C68.8324 16.108 68.9545 15.517 69.1989 15.0057C69.446 14.4915 69.7898 14.0909 70.2301 13.804C70.6733 13.5142 71.1903 13.3693 71.7812 13.3693C72.1222 13.3693 72.4588 13.4261 72.7912 13.5398C73.1236 13.6534 73.4261 13.8381 73.6989 14.0938C73.9716 14.3466 74.1889 14.6818 74.3509 15.0994C74.5128 15.517 74.5938 16.0312 74.5938 16.642V17.0682H69.5483V16.1989H73.571C73.571 15.8295 73.4972 15.5 73.3494 15.2102C73.2045 14.9205 72.9972 14.6918 72.7273 14.5241C72.4602 14.3565 72.1449 14.2727 71.7812 14.2727C71.3807 14.2727 71.0341 14.3722 70.7415 14.571C70.4517 14.767 70.2287 15.0227 70.0724 15.3381C69.9162 15.6534 69.8381 15.9915 69.8381 16.3523V16.9318C69.8381 17.4261 69.9233 17.8452 70.0938 18.1889C70.267 18.5298 70.5071 18.7898 70.8139 18.9688C71.1207 19.1449 71.4773 19.233 71.8835 19.233C72.1477 19.233 72.3864 19.196 72.5994 19.1222C72.8153 19.0455 73.0014 18.9318 73.1577 18.7812C73.3139 18.6278 73.4347 18.4375 73.5199 18.2102L74.4915 18.483C74.3892 18.8125 74.2173 19.1023 73.9759 19.3523C73.7344 19.5994 73.4361 19.7926 73.081 19.9318C72.7259 20.0682 72.3267 20.1364 71.8835 20.1364ZM77.1293 16.0625V20H76.1236V13.4545H77.0952V14.4773H77.1804C77.3338 14.1449 77.5668 13.8778 77.8793 13.6761C78.1918 13.4716 78.5952 13.3693 79.0895 13.3693C79.5327 13.3693 79.9205 13.4602 80.2528 13.642C80.5852 13.821 80.8438 14.0938 81.0284 14.4602C81.2131 14.8239 81.3054 15.2841 81.3054 15.8409V20H80.2997V15.9091C80.2997 15.3949 80.1662 14.9943 79.8991 14.7074C79.6321 14.4176 79.2656 14.2727 78.7997 14.2727C78.4787 14.2727 78.1918 14.3423 77.9389 14.4815C77.6889 14.6207 77.4915 14.8239 77.3466 15.0909C77.2017 15.358 77.1293 15.6818 77.1293 16.0625ZM87.2681 17.3239V13.4545H88.2738V20H87.2681V18.892H87.1999C87.0465 19.2244 86.8079 19.5071 86.484 19.7401C86.1602 19.9702 85.7511 20.0852 85.2567 20.0852C84.8477 20.0852 84.484 19.9957 84.1658 19.8168C83.8477 19.6349 83.5977 19.3622 83.4158 18.9986C83.234 18.6321 83.1431 18.1705 83.1431 17.6136V13.4545H84.1488V17.5455C84.1488 18.0227 84.2823 18.4034 84.5494 18.6875C84.8192 18.9716 85.163 19.1136 85.5806 19.1136C85.8306 19.1136 86.0849 19.0497 86.3434 18.9219C86.6048 18.794 86.8235 18.598 86.9996 18.3338C87.1786 18.0696 87.2681 17.733 87.2681 17.3239Z"
                          fill="black"
                        />
                        <rect
                          x="0.5"
                          y="0.5"
                          width="97"
                          height="31"
                          rx="15.5"
                          stroke="black"
                          strokeOpacity="0.1"
                        />
                      </svg>
                    )
                  ) : (
                    <OverlayTrigger
                      key={"hideboard"}
                      placement={"right"}
                      overlay={
                        <Tooltip id={`show-menu`}>
                          <strong>Show Menu</strong>
                        </Tooltip>
                      }
                    >
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={this.hideMenu}
                      >
                        <path
                          d="M10 12H22"
                          stroke="#202223"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M10 16H22"
                          stroke="#202223"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M10 20H22"
                          stroke="#202223"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <rect
                          x="0.5"
                          y="0.5"
                          width="31"
                          height="31"
                          rx="15.5"
                          stroke="black"
                          strokeOpacity="0.1"
                        />
                      </svg>
                    </OverlayTrigger>
                  )}
                </>
              )}
              <ol className="breadcrumb">
                <li className="breadcrumb-item" aria-current="page">
                  <div className="muBtn _link breadcrumb-item active">
                    <Link className="muBtn _link" to="/board/list">
                      Tattle{" "}
                    </Link>
                    <div className="breadcrumb-item active">
                      <div className="muBtn _link">
                        {this.props.brecum_name?.name !== "" ? (
                          breadcrumb
                        ) : (
                          <div className="breadcrumb-item active">
                            {breadcrumb}
                          </div>
                        )}{" "}
                        {this.props.brecum_name?.name !== "" ? (
                          <div className="breadcrumb-item active">
                            {this.props.brecum_name?.name}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </li>
              </ol>
            </div>
            {/* Help Center */}
            <div className="muBtn-group h-100">
              {/* <div
              className="muBtn _light icon-before"
              id="btn_help_center"
              title="Help Center"
            >
              <span className="svg">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.99999 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 9.99999C18.3333 5.39762 14.6024 1.66666 9.99999 1.66666C5.39762 1.66666 1.66666 5.39762 1.66666 9.99999C1.66666 14.6024 5.39762 18.3333 9.99999 18.3333Z"
                    stroke="#5C5F62"
                    strokeWidth="1.33"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7.57501 7.49999C7.77093 6.94304 8.15764 6.47341 8.66664 6.17426C9.17564 5.87512 9.77409 5.76577 10.356 5.86558C10.9379 5.96539 11.4657 6.26792 11.8459 6.71959C12.2261 7.17126 12.4342 7.74292 12.4333 8.33332C12.4333 9.99999 9.93335 10.8333 9.93335 10.8333"
                    stroke="#5C5F62"
                    strokeWidth="1.33"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M10 14.1667H10.0083"
                    stroke="#5C5F62"
                    strokeWidth="1.33"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              Help Center
            </div> */}
              {/* Help Center */}
              <div
                class="muBtn _light icon-before help_center_icon"
                id="btn_help_center"
                // title="Help Center"
              >
                <span class="svg">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.99999 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 9.99999C18.3333 5.39762 14.6024 1.66666 9.99999 1.66666C5.39762 1.66666 1.66666 5.39762 1.66666 9.99999C1.66666 14.6024 5.39762 18.3333 9.99999 18.3333Z"
                      stroke="#5C5F62"
                      stroke-width="1.33"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M7.57501 7.49999C7.77093 6.94304 8.15764 6.47341 8.66664 6.17426C9.17564 5.87512 9.77409 5.76577 10.356 5.86558C10.9379 5.96539 11.4657 6.26792 11.8459 6.71959C12.2261 7.17126 12.4342 7.74292 12.4333 8.33332C12.4333 9.99999 9.93335 10.8333 9.93335 10.8333"
                      stroke="#5C5F62"
                      stroke-width="1.33"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M10 14.1667H10.0083"
                      stroke="#5C5F62"
                      stroke-width="1.33"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                </span>
                <a
                  href="https://help.muvi.com/help/how-to-use-tattle-as-a-user"
                  target="_blank"
                >
                  Help Center
                </a>
              </div>
              {this.state?.userDetails?.length >= 2 && (
                <div className="dropdown mu-dropdown border-0 multi_user">
                  <div
                    className="muBtn _light icon-only"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    data-bs-tooltip="tooltip"
                    data-bs-placement="bottom"
                    title=""
                    id="btn_products_list"
                    data-bs-auto-close="true"
                    data-bs-original-title="Products"
                  >
                    <span className="svg">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.16634 5C4.62658 5 4.99967 4.6269 4.99967 4.16667C4.99967 3.70643 4.62658 3.33333 4.16634 3.33333C3.7061 3.33333 3.33301 3.70643 3.33301 4.16667C3.33301 4.6269 3.7061 5 4.16634 5Z"
                          stroke="#5C5F62"
                          strokeWidth="1.33"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M4.16634 10.8333C4.62658 10.8333 4.99967 10.4602 4.99967 10C4.99967 9.53976 4.62658 9.16667 4.16634 9.16667C3.7061 9.16667 3.33301 9.53976 3.33301 10C3.33301 10.4602 3.7061 10.8333 4.16634 10.8333Z"
                          stroke="#5C5F62"
                          strokeWidth="1.33"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M4.16634 16.6667C4.62658 16.6667 4.99967 16.2936 4.99967 15.8333C4.99967 15.3731 4.62658 15 4.16634 15C3.7061 15 3.33301 15.3731 3.33301 15.8333C3.33301 16.2936 3.7061 16.6667 4.16634 16.6667Z"
                          stroke="#5C5F62"
                          strokeWidth="1.33"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M10.0003 5C10.4606 5 10.8337 4.6269 10.8337 4.16667C10.8337 3.70643 10.4606 3.33333 10.0003 3.33333C9.54009 3.33333 9.16699 3.70643 9.16699 4.16667C9.16699 4.6269 9.54009 5 10.0003 5Z"
                          stroke="#5C5F62"
                          strokeWidth="1.33"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M10.0003 10.8333C10.4606 10.8333 10.8337 10.4602 10.8337 10C10.8337 9.53976 10.4606 9.16667 10.0003 9.16667C9.54009 9.16667 9.16699 9.53976 9.16699 10C9.16699 10.4602 9.54009 10.8333 10.0003 10.8333Z"
                          stroke="#5C5F62"
                          strokeWidth="1.33"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M10.0003 16.6667C10.4606 16.6667 10.8337 16.2936 10.8337 15.8333C10.8337 15.3731 10.4606 15 10.0003 15C9.54009 15 9.16699 15.3731 9.16699 15.8333C9.16699 16.2936 9.54009 16.6667 10.0003 16.6667Z"
                          stroke="#5C5F62"
                          strokeWidth="1.33"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M15.8333 5C16.2936 5 16.6667 4.6269 16.6667 4.16667C16.6667 3.70643 16.2936 3.33333 15.8333 3.33333C15.3731 3.33333 15 3.70643 15 4.16667C15 4.6269 15.3731 5 15.8333 5Z"
                          stroke="#5C5F62"
                          strokeWidth="1.33"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M15.8333 10.8333C16.2936 10.8333 16.6667 10.4602 16.6667 10C16.6667 9.53976 16.2936 9.16667 15.8333 9.16667C15.3731 9.16667 15 9.53976 15 10C15 10.4602 15.3731 10.8333 15.8333 10.8333Z"
                          stroke="#5C5F62"
                          strokeWidth="1.33"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M15.8333 16.6667C16.2936 16.6667 16.6667 16.2936 16.6667 15.8333C16.6667 15.3731 16.2936 15 15.8333 15C15.3731 15 15 15.3731 15 15.8333C15 16.2936 15.3731 16.6667 15.8333 16.6667Z"
                          stroke="#5C5F62"
                          strokeWidth="1.33"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                    </span>
                  </div>
                  <div
                    className="dropdown-menu"
                    aria-labelledby="btn_products_list"
                    style={{
                      minWidth: "180px",
                      position: "absolute",
                      inset: "0px auto auto 0px",
                      margin: "0px",
                      transform: "translate(1189px, 50px)",
                    }}
                    dataPopperPlacement="bottom-start"
                  >
                    {this.state.userDetails.map((item, index) => {
                      return (
                        <div
                          className={`dropdown-item ${
                            this.state.app_token === item.app_token
                              ? "active"
                              : ""
                          }`}
                          key={index}
                        >
                          <span className="svg me-3" title={item?.company_name}>
                            <Link
                              to={`/switch-account/${item.app_token}`}
                              style={{ textDecoration: "none" }}
                              className={`nav-link ${
                                this.state.app_token == item.app_token
                                  ? "disabled"
                                  : ""
                              }`}
                            >
                              <i
                                className="fa fa-sign-in"
                                aria-hidden="true"
                              ></i>
                              &nbsp;
                              {item?.company_name}
                            </Link>
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              <div className="dropdown mu-dropdown ms-2">
                <div
                  className="muBtn _light icon-after dropdown-toggle h-100 p-3"
                  id="dropdownMenuReference"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="true"
                  data-bs-reference="parent"
                >
                  {this.state.user_name}
                  <span className="svg">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4 6L8 10L12 6"
                        stroke="#7B8794"
                        strokeWidth="1.33"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </div>
                <div className="dropdown-menu" id="dropdownMenuReference">
                  <div className="dropdown-item">
                    <div className="d-flex align-items-center">
                      <span className="svg">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.6667 7.33334H3.33333C2.59695 7.33334 2 7.9303 2 8.66668V13.3333C2 14.0697 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0697 14 13.3333V8.66668C14 7.9303 13.403 7.33334 12.6667 7.33334Z"
                            stroke="#5C5F62"
                            strokeWidth="1.33"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M4.66666 7.33334V4.66668C4.66666 3.78262 5.01785 2.93478 5.64297 2.30965C6.2681 1.68453 7.11594 1.33334 8 1.33334C8.88405 1.33334 9.7319 1.68453 10.357 2.30965C10.9821 2.93478 11.3333 3.78262 11.3333 4.66668V7.33334"
                            stroke="#5C5F62"
                            strokeWidth="1.33"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <Link className="dropdown-item" to="/logout">
                        Logout
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      )
    );
  }
}
const mapStateToProps = (state) => {
  return {
    toggleMenuAction: state.boardAttribute.toggleMenu,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleMenu: () => {
      dispatch(action.toggleMenu());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Header);
